/**
 * Kindred & Kin search (Horizon-style)
 * - Desktop/tablet (768px+): a results panel opens under the header search bar.
 * - Phones (under 768px): tapping the search icon opens a full-screen search sheet.
 * The header search bar and mobile icon themselves are unchanged.
 * Results are rendered by sections/kk-predictive-search.liquid.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 767;
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  var SECTION = 'kk-predictive-search';
  var RECENT_KEY = 'recently-viewed';

  var BRAND_MAP = [
    { terms: ['benamor', 'benamôr'], handle: 'benamor-lisbon-1925', min: 6 },
    { terms: ['castelbel'], handle: 'castelbel', min: 6 },
    { terms: ['portus cale', 'portus'], handle: 'portus-cale', min: 6 },
    { terms: ['vista alegre'], handle: 'vista-alegre', min: 5 },
    { terms: ['bombchel'], handle: 'bombchel', min: 7 },
    { terms: ['bathorium'], handle: 'bathorium', min: 6 },
    { terms: ['brooklyn tea', 'brooklyn'], handle: 'ritual-teas', min: 8 },
    { terms: ['fair trade egypt'], handle: 'fair-trade-egypt', min: 9 },
    { terms: ['belart'], handle: 'belart-fair-trade', min: 5 },
    { terms: ['kosta boda'], handle: 'kosta-boda', min: 9 },
    { terms: ['dakar market', 'dakar'], handle: 'dakar-market-edit', min: 5 }
  ];

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var searchUrl = (window.theme && theme.routes && theme.routes.search_url) || root + 'search';
  var suggestUrl = (window.theme && theme.routes && theme.routes.predictive_search_url) || root + 'search/suggest';

  function isMobile() { return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function viewAllUrl(query) {
    var q = query.toLowerCase().trim();
    for (var i = 0; i < BRAND_MAP.length; i++) {
      var b = BRAND_MAP[i];
      if (q.length < b.min) continue;
      for (var j = 0; j < b.terms.length; j++) {
        if (b.terms[j].indexOf(q) === 0 || q === b.terms[j]) return root + 'collections/' + b.handle;
      }
    }
    return searchUrl + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
  }

  function recentHandles() {
    try {
      var ids = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(ids) ? ids.filter(Boolean).slice(0, 6) : [];
    } catch (e) { return []; }
  }

  function loadCss() {
    var script = document.querySelector('script[src*="inline-search.js"]');
    if (!script || document.getElementById('kk-search-css')) return;
    var link = document.createElement('link');
    link.id = 'kk-search-css';
    link.rel = 'stylesheet';
    link.href = script.src.replace(/inline-search\.js(\?.*)?$/, 'kk-search.css$1');
    document.head.appendChild(link);
  }

  function init() {
    var headerForm = document.querySelector('.thb-inline-search');
    var headerInput = headerForm && headerForm.querySelector('.thb-inline-search__input');
    if (!headerForm || !headerInput) return;
    loadCss();

    // ---------- Build the shell (one panel, styled as dropdown or full-screen sheet) ----------
    var backdrop = document.createElement('div');
    backdrop.className = 'kk-search-backdrop';
    backdrop.hidden = true;

    var panel = document.createElement('div');
    panel.className = 'kk-search';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Search');
    panel.innerHTML =
      '<form class="kk-search__bar" role="search" action="' + esc(searchUrl) + '" method="get">' +
        '<span class="kk-search__icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="18" height="18"><circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>' +
        '<input class="kk-search__input" type="search" name="q" placeholder="Search Kindred &amp; Kin" autocomplete="off" autocorrect="off" spellcheck="false" aria-label="Search">' +
        '<button type="button" class="kk-search__clear" aria-label="Clear search" hidden>&times;</button>' +
        '<button type="button" class="kk-search__close">Cancel</button>' +
      '</form>' +
      '<div class="kk-search__progress" aria-hidden="true"></div>' +
      '<div class="kk-search__body" tabindex="-1"></div>' +
      '<div class="kk-search__footer" hidden><a class="kk-search__all" data-kk-item href="#"></a></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    var sheetForm = panel.querySelector('.kk-search__bar');
    var sheetInput = panel.querySelector('.kk-search__input');
    var clearBtn = panel.querySelector('.kk-search__clear');
    var closeBtn = panel.querySelector('.kk-search__close');
    var body = panel.querySelector('.kk-search__body');
    var footer = panel.querySelector('.kk-search__footer');
    var allLink = panel.querySelector('.kk-search__all');

    var open = false;
    var mode = null; // 'panel' | 'sheet'
    var controller = null;
    var cache = new Map();
    var lastQuery = null;
    var pushedState = false;
    var opener = null;

    function activeInput() { return mode === 'sheet' ? sheetInput : headerInput; }

    // ---------- Fetching ----------
    function render(html, query) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var results = doc.querySelector('[data-kk-results]');
      if (!results) return;
      body.innerHTML = results.outerHTML;
      body.scrollTop = 0;
      var hasResults = !!body.querySelector('[data-kk-has-results]');
      if (query && hasResults) {
        allLink.href = viewAllUrl(query);
        allLink.innerHTML = 'View all results for &ldquo;' + esc(query) + '&rdquo; <span aria-hidden="true">&rarr;</span>';
        footer.hidden = false;
      } else {
        footer.hidden = true;
      }
      panel.classList.remove('is-loading');
    }

    function fetchHtml(url, key, query) {
      if (cache.has(key)) { render(cache.get(key), query); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      panel.classList.add('is-loading');
      fetch(url, { signal: controller.signal, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (cache.size > 40) cache.delete(cache.keys().next().value);
          cache.set(key, html);
          if (open) render(html, query);
        })
        .catch(function (e) { if (e.name !== 'AbortError') panel.classList.remove('is-loading'); });
    }

    function loadEmptyState() {
      var handles = recentHandles();
      if (handles.length) {
        var q = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
        fetchHtml(searchUrl + '?type=product&q=' + encodeURIComponent(q) + '&section_id=' + SECTION, 'recent:' + q, null);
      } else {
        fetchHtml(root + '?section_id=' + SECTION, 'empty', null);
      }
    }

    function search(query) {
      query = query.trim();
      if (query === lastQuery) return;
      lastQuery = query;
      clearBtn.hidden = !sheetInput.value;
      if (query.length < MIN_CHARS) { loadEmptyState(); return; }
      var params = new URLSearchParams({
        q: query,
        'resources[type]': 'query,product,collection,page,article',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,vendor,variants.title,variants.sku,tag',
        section_id: SECTION
      });
      fetchHtml(suggestUrl + '?' + params.toString(), 'q:' + query.toLowerCase(), query);
    }

    var timer;
    function debouncedSearch(q) { clearTimeout(timer); timer = setTimeout(function () { search(q); }, DEBOUNCE_MS); }

    // ---------- Positioning (desktop panel sits right under the header bar) ----------
    function position() {
      if (mode !== 'panel') return;
      var header = document.querySelector('.header-section') || document.getElementById('header');
      var hb = header ? header.getBoundingClientRect() : { bottom: 70 };
      var fb = headerForm.getBoundingClientRect();
      var top = Math.max(hb.bottom, fb.bottom + 8);
      var width = Math.min(960, window.innerWidth - 32);
      var right = Math.max(16, window.innerWidth - fb.right);
      if (window.innerWidth - right - width < 16) right = window.innerWidth - width - 16;
      panel.style.top = top + 'px';
      panel.style.right = right + 'px';
      panel.style.width = width + 'px';
      panel.style.maxHeight = Math.min(window.innerHeight - top - 24, Math.max(420, window.innerHeight * 0.75)) + 'px';
      backdrop.style.top = top + 'px';
    }

    // ---------- Open / close ----------
    function openSearch(asSheet) {
      if (open) return;
      open = true;
      mode = asSheet ? 'sheet' : 'panel';
      opener = document.activeElement;
      panel.classList.toggle('kk-search--sheet', asSheet);
      panel.classList.toggle('kk-search--panel', !asSheet);
      panel.setAttribute('aria-modal', asSheet ? 'true' : 'false');
      panel.hidden = false;
      backdrop.hidden = asSheet;
      if (asSheet) {
        sheetInput.value = headerInput.value || '';
        clearBtn.hidden = !sheetInput.value;
        sheetInput.focus(); // same tap, so phones raise the keyboard
        document.documentElement.classList.add('kk-search-lock');
        try { history.pushState({ kkSearch: true }, ''); pushedState = true; } catch (e) {}
      } else {
        position();
      }
      requestAnimationFrame(function () { panel.classList.add('is-open'); backdrop.classList.add('is-open'); });
      lastQuery = null;
      search(activeInput().value);
    }

    function closeSearch(fromPop) {
      if (!open) return;
      open = false;
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.documentElement.classList.remove('kk-search-lock');
      if (controller) controller.abort();
      var wasSheet = mode === 'sheet';
      setTimeout(function () { if (!open) { panel.hidden = true; backdrop.hidden = true; } }, 200);
      if (wasSheet) {
        if (pushedState && !fromPop) { pushedState = false; history.back(); }
        pushedState = false;
        headerInput.value = sheetInput.value;
        if (opener && opener.blur) opener.blur();
      }
      mode = null;
    }

    // ---------- Header bar (desktop) and icon (phones) ----------
    headerForm.addEventListener('pointerdown', function (e) {
      if (isMobile()) e.preventDefault(); // keep the icon as an icon; open the sheet instead
    });
    headerForm.addEventListener('click', function (e) {
      if (isMobile()) { e.preventDefault(); openSearch(true); }
    });
    headerInput.addEventListener('focus', function () {
      if (isMobile()) { headerInput.blur(); openSearch(true); }
      else openSearch(false);
    });
    headerInput.addEventListener('input', function () {
      if (!open) openSearch(false);
      debouncedSearch(headerInput.value);
    });
    headerForm.addEventListener('submit', function (e) {
      if (!headerInput.value.trim()) e.preventDefault();
    });

    // ---------- Sheet bar ----------
    sheetInput.addEventListener('input', function () { clearBtn.hidden = !sheetInput.value; debouncedSearch(sheetInput.value); });
    sheetForm.addEventListener('submit', function (e) { if (!sheetInput.value.trim()) e.preventDefault(); });
    clearBtn.addEventListener('click', function () { sheetInput.value = ''; clearBtn.hidden = true; sheetInput.focus(); search(''); });
    closeBtn.addEventListener('click', function () { closeSearch(false); });
    backdrop.addEventListener('click', function () { closeSearch(false); });
    window.addEventListener('popstate', function () { if (open && mode === 'sheet') { pushedState = false; closeSearch(true); } });

    // Clear recently viewed
    body.addEventListener('click', function (e) {
      if (e.target.closest('[data-kk-clear-recent]')) {
        e.preventDefault();
        try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
        cache.forEach(function (_, k) { if (k.indexOf('recent:') === 0) cache.delete(k); });
        lastQuery = null;
        loadEmptyState();
      }
    });

    // Close when clicking elsewhere (desktop)
    document.addEventListener('mousedown', function (e) {
      if (!open || mode !== 'panel') return;
      if (panel.contains(e.target) || headerForm.contains(e.target)) return;
      closeSearch(false);
    });

    // ---------- Keyboard ----------
    function items() { return Array.prototype.slice.call(panel.querySelectorAll('.kk-search__body [data-kk-item], .kk-search__footer:not([hidden]) [data-kk-item]')); }
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        var wasPanel = mode === 'panel';
        closeSearch(false);
        if (wasPanel) headerInput.blur();
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var list = items();
      if (!list.length) return;
      var idx = list.indexOf(document.activeElement);
      var inInput = document.activeElement === activeInput();
      if (!inInput && idx === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') {
        (inInput ? list[0] : list[Math.min(idx + 1, list.length - 1)]).focus();
      } else if (idx <= 0) {
        activeInput().focus();
      } else {
        list[idx - 1].focus();
      }
    });
    // Keep keyboard focus inside the full-screen sheet
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || mode !== 'sheet') return;
      var f = Array.prototype.slice.call(panel.querySelectorAll('input, button:not([hidden]), a[href]')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    // Leaving the panel with Tab on desktop closes it
    panel.addEventListener('focusout', function () {
      setTimeout(function () {
        if (open && mode === 'panel' && !panel.contains(document.activeElement) && document.activeElement !== headerInput) closeSearch(false);
      }, 0);
    });

    // ---------- Keep layout right ----------
    var raf;
    function onViewport() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (!open) return;
        if ((mode === 'sheet') !== isMobile()) { closeSearch(false); return; }
        position();
      });
    }
    window.addEventListener('resize', onViewport);
    window.addEventListener('scroll', onViewport, { passive: true });

    // Warm the cache for the empty state so the first open feels instant
    if ('requestIdleCallback' in window) requestIdleCallback(function () { if (!recentHandles().length) fetch(root + '?section_id=' + SECTION).then(function (r) { return r.text(); }).then(function (h) { cache.set('empty', h); }).catch(function () {}); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
